import React, { Component } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import ToggleSwitch from './common/toggleSwitch';
import Table from './common/table';
import auth from '../services/authService';

const $ = require('jquery');
$.DataTable = require('datatables.net');

class GTradesTable extends Component {
  columns = [
    {
      path: 'user',
      label: 'By',
      //content: user => <Link to={`/users/${user._id}`}>{user.phoneNumber}</Link>
    },
    {
      path: 'card_value',
      label: 'Card Amount',
      content: (gtrade) => gtrade.card_value,
    },
    {
      path: 'cardCountry',
      label: 'Card Amount',
      content: (gtrade) => gtrade.cardCountry,
    },
    {
      path: 'amountToReceive',
      label: 'Amount(₦)',
      content: (gtrade) => `₦${gtrade.amountToReceive}`,
    },
    {
      path: 'card_type',
      label: 'Card Type',
      content: (gtrade) => gtrade.cardType,
    },
    {
      path: 'card_brand',
      label: 'Card Brand',
      content: (gtrade) => gtrade.cardBrand,
    },
    {
      path: 'trade_reference',
      label: 'Reference',
      content: (gtrade) => gtrade.trade_reference,
    },
    {
      path: 'created_at',
      label: 'Trade Date',
      content: (gtrade) =>
      // gtrade.created_at,
        moment(gtrade.created_at).startOf('day').format('LL'),
    },
    {
      key: (gtrade) => `${gtrade._id}-cl`,
      label: 'Closed?',
      content: (gtrade) => (
        <ToggleSwitch
          switched={gtrade.isCompleted}
          handleChange={() => this.props.onCompleteSwitch(gtrade)}
        />
      ),
    },
    {
      key: (gtrade) => `${gtrade._id}-ap`,
      label: 'Approved?',
      content: (gtrade) => (
        <ToggleSwitch
          switched={gtrade.isApproved}
          handleChange={() => this.props.onApproveSwitch(gtrade)}
        />
      ),
    },
    {
      key: (gtrade) => `${gtrade._id}-s`,
      label: 'Info',
      content: (gtrade) => (
        <Link
          to={`/gcards/show/${gtrade._id}`}
          className="btn btn-primary btn-sm"
        >
          View
        </Link>
      ),
    },
  ];

  deleteColumn = {
    key: 'delete',
    label: 'Delete',
    content: (gtrade) => (
      <button
        onClick={() => this.props.onDelete(gtrade)}
        className="btn btn-danger btn-sm"
      >
        Delete
      </button>
    ),
  };

  editColumn = {
    key: 'edit',
    label: 'Edit',
    content: (gtrade) => (
      <Link to={`/gcards/edit/${gtrade._id}`} className="btn btn-custom btn-sm">
        Edit
      </Link>
    ),
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    if (user && user.isAdmin) {
      //this.columns.push(this.editColumn);
      //this.columns.push(this.deleteColumn);
    }
  }

  componentDidMount() {
    $(document).ready(function () {
      $('#dataTable').DataTable();
    });
  }

  render() {
    const { gtrades, message } = this.props;
    return <Table columns={this.columns} data={gtrades} message={message} />;
  }
}

export default GTradesTable;
